import * as Y from "yjs";
//const {encodeStateAsUpdate,applyUpdate} = Y;
import React,{useEffect, useRef, useState} from 'react';
import './historyStyle.css';
import {openTask,historyClose,restoreSelectionHistory} from './uiEventHandler'

async function getSprintHistory(teamNumber){
    //const updates = null;

//保存先を変えた関係で取ってきたデータすべてをそのまま渡すのでよさそう
//async function getSprintHistory(teamNumber) {
    try {
        const response = await fetch('https://night.eng.tamagawa.ac.jp/yjs/api/history', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ teamNumber })
        });

        if (response.status === 200) {
            const data = await response.json();
            const updates = data.updates;
            const reUpdates = [];
            const historyDoc = [];
            let dataCheck = false;
            const updatesList = [];
            

            
            updates.forEach(update => {
                let tempDoc = new Y.Doc();
                reUpdates.push(new Uint8Array(update.data));
                try{
                    Y.applyUpdate(tempDoc,new Uint8Array(update.data));
                    if(tempDoc.share.size > 0){
                        if(tempDoc.share.has(`sprintboard-${teamNumber}:${teamNumber}`)){
                            dataCheck = true;
                            historyDoc.push(tempDoc);
                            updatesList.push(new Uint8Array(update.data));
                        }
                        else{
                            dataCheck = false;
                        }
                    }
                    else if(dataCheck){
                        historyDoc.push(tempDoc);
                        updatesList.push(new Uint8Array(update.data));
                    }
                }
                catch(error){
                  console.log("error",error);
                }
                
            });
            
            return updatesList;
        } else if (response.status === 401) {
            throw new Error('history not exist');
        } else {
            throw new Error('Internal server error');
        }
    } catch (error) {
        console.error(error.message);
        return [];
    }
//}


        
}
export {getSprintHistory,HistoryHandler };

const maps = [
    "ProductBacklog",
    "SprintBacklog",
    "investigation0","investigation1","investigation2","investigation3","investigation4",
    "doing0","doing1","doing2","doing3","doing4",
    "done0","done1","done2","done3","done4",
  ];
  //最新の状態のyDataは履歴のリストに使い，選択中の状態は別で保持
  //そのうち，setDataをする場所でallEntrisの中にMemberNameも入れればよいのでは？
  let yData;
  let selectYData;
  

  //= useRef(null)にして、tempYDoc.current=yDocの形のほうがいいかも
  //let tempYDoc = useRef(null);
  let tempYDoc;

  let tempTeamNum;

  let isEffectExecuted = false;

  let selectIndex = null;


  //※スナップショット機能があるようなので履歴のリストに合わせたスナップショットを作っておいたほうが効率的の可能性が高い
  //ただし、履歴の復元はスナップショットから行わないほうが良いっぽい

function HistoryHandler(props){
    const [isEffect, setIsEffect] = useState(false);
    let historyCount = 22;
    const [data,setData] = useState({});

    //historyMake(historyCount);

    const newHistory = [];
    //const timeArray = [];

    const [timeArray,setTimeArray] = useState([]);
    const [historyArray,setHistoryArray] = useState({});

    const [openSprints, setOpenSprints] = useState({});
    //historyMake();

    function historyMake(){

        const yDoc = new Y.Doc();

        const newArray = [];
        const historyMap = {};

        for(let i = 0;i < props.updatesList.length;i++){
            Y.applyUpdate(yDoc,props.updatesList[i]);
            //const currentYData = yDoc.getMap(`sprintboard:${props.teamNumber}`);
            const currentYData = yDoc.getMap(`sprintboard-${props.teamNumber}:${props.teamNumber}`);
            
            const sprintNum = currentYData.get("SprintInfo").get("CurrentSprint");
            const taskAction = currentYData.get("TaskAction");
            const sprintState = taskAction ? taskAction.get("sprintState") : "nonState";
            //const changeTime = currentYData.get("changeTime");
            const changeTime = taskAction ? taskAction.get("changeTime") : "0";

            const actionTaskTitle = taskAction ? taskAction.get("actionTaskTitle") : "";

            if(!historyMap[sprintNum]) historyMap[sprintNum] = [];
            historyMap[sprintNum].push({
                sprintState,
                changeTime,
                index:i,
                actionTaskTitle
            })
        }
        yData = yDoc.getMap(`sprintboard-${props.teamNumber}:${props.teamNumber}`);
        
        //setTimeArray(newArray);
        setHistoryArray(historyMap);
        
    }
    

    const updateData = () => {

        const allEntries = updateTasks();

        historyMake();
      
        setData({
          ProductBacklog: allEntries["ProductBacklog"],
            SprintBacklog: allEntries["SprintBacklog"],
            investigation0: allEntries["investigation0"],
            investigation1: allEntries["investigation1"],
            investigation2: allEntries["investigation2"],
            investigation3: allEntries["investigation3"],
            investigation4: allEntries["investigation4"],
            doing0: allEntries["doing0"],
            doing1: allEntries["doing1"],
            doing2: allEntries["doing2"],
            doing3: allEntries["doing3"],
            doing4: allEntries["doing4"],
            done0: allEntries["done0"],
            done1: allEntries["done1"],
            done2: allEntries["done2"],
            done3: allEntries["done3"],
            done4: allEntries["done4"],
        });
        
      };

      useEffect(() => {
        if(isEffectExecuted) return;
        isEffectExecuted = true;
        historyMake();
        updateData();
      },[]);


      //updatesListが更新されたら履歴を更新．historyを開いたときに最新の状態にするため
      useEffect(() => {
        historyMake();
      },[props.updatesList]);
      
      const listItemClick = (index) => {
        const newDoc = new Y.Doc();
        for(let i = 0;i <= index;i++){
            Y.applyUpdate(newDoc,props.updatesList[i]);
        }

        yData = newDoc.getMap(`sprintboard-${props.teamNumber}:${props.teamNumber}`);
        selectYData = newDoc.getMap(`sprintboard-${props.teamNumber}:${props.teamNumber}`);

        selectIndex = index;

        updateData();

        

        //履歴リストをクリックしたタイミングでyDocを保存しておく→復元ボタンクリックを押されたら渡す
        tempYDoc = newDoc;
        tempTeamNum = props.teamNumber;
        
      }

      const toggleSprint = (sprintNum) => {
        setOpenSprints(prev => ({
            ...prev,
            [sprintNum]: !prev[sprintNum]
        }));
    };

    return(
        <div className="hAllgrid">
            <div className="hHeader">
                <div className="history" id="history" /*onClick={() => historyDisplay(teamNumber)}*/>
                    <button className="historyButton" id="historyButton" onClick={() => historyClose()}/* 閉じる*/>閉じる</button>
                </div>
                <div className="restoreHistory" id="restoreHistory">
                    <button className="restoreButton" id="restoreButton" onClick={() => 
                    {restoreSelectionHistory(selectYData,tempTeamNum);}}>復元</button>
                </div>
            </div>
            <div className="hMain">
                <div className='historyList'>
                    {Object.keys(historyArray).map(sprintNum => (
                    <div key={sprintNum} className="sprint-group">
                        <div className="sprint-header" onClick={() => toggleSprint(sprintNum)}>
                            <strong>Sprint {sprintNum}</strong> [{openSprints[sprintNum] ? '−' : '+'}]
                        </div>
                        {openSprints[sprintNum] && (
                            <ul className="history-items">
                                {historyArray[sprintNum].map((entry, i) => {
                                    if(entry.sprintState === "SprintTotal" || entry.sprintState === "ChangeCurrentSprint" || 
                                        entry.sprintState === "playerLogin" || entry.sprintState === "move" || entry.sprintState === "resize"){
                                        return null;
                                    }
                                    return(
                                    <li
                                        key={entry.index}
                                        className={`historyItem ${selectIndex === entry.index ? 'selected' : ''}`}
                                        onClick={() => listItemClick(entry.index)}
                                    >
                                        
                                        <div className="sprint-state">{entry.sprintState}</div>
                                        <div className="history-taskTitle">{entry.actionTaskTitle}</div>
                                        <div className="history-time">{entry.changeTime}</div>
                                    </li>
                                    )
                                    
                                })}
                            </ul>
                        )}
                    </div>
                    ))}
                    {/* {props.updatesList.map((dic,index) => {
                        //選択したindexに到達した場合はisSelectを青にし，nullにする
                        const isSelect = index === selectIndex;
                        if(isSelect){selectIndex = null;}
                        
                        return(
                            <div className='historyItem' datakey = {index} key={index} 
                            onClick={() => listItemClick(index)} style={isSelect?{backgroundColor:"blue"}:{}}>   
                                {timeArray[index]}
                            </div>);
                    })} */}
                </div>
                
                <div className="hBoard">
                    <div className="hItems">
                        <div className="hItem pBacklog" /*onClick={handleButtonClick}*//*プロダクトバックログ*/>プロダクトバックログ
                            <button id="makeTask" >+</button>
                        </div>
                        <div className="hItem sBacklog" /* スプリントバックログ*/>スプリントバックログ</div>
                        <div className="hItem nameGrid" /*名前*/>名前</div>
                        <div className="hItem investigation" /* 調査中*/>調査中</div>
                        <div className="hItem doing" >Doing</div>
                        <div className="hItem done" >Done</div>
                    </div>
                

                    <div className="hGrids">
                        <div className="grid  hGridCSS pBacklog" id="ProductBacklog">
                            {Array.isArray(data.ProductBacklog) ? data.ProductBacklog : null}
                    
                    
                        </div>

                        <div className="grid hGridCSS sBacklog" id="SprintBacklog">
                            {Array.isArray(data.SprintBacklog) ? data.SprintBacklog : null}
                        </div>

                        <div className="hGridCSS nameGrid" >
                            <div className="nameTag name0">{selectYData?.get("MemberName")?.get("0") || "0"}</div>
                            <div className="nameTag name1">{selectYData?.get("MemberName")?.get("1") || "1"}</div>
                            <div className="nameTag name2">{selectYData?.get("MemberName")?.get("2") || "2"}</div>
                            <div className="nameTag name3">{selectYData?.get("MemberName")?.get("3") || "3"}</div>
                            <div className="nameTag name4">{selectYData?.get("MemberName")?.get("4") || "4"}</div>
                        </div>

                        <div className=" hGridCSS investigation" id="investigation">
                            <div className="grid type0 " id="investigation0">{Array.isArray(data.investigation0) ? data.investigation0 : null}</div>
                            <div className="grid type1 " id="investigation1">{Array.isArray(data.investigation1) ? data.investigation1 : null}</div>
                            <div className="grid type2 " id="investigation2">{Array.isArray(data.investigation2) ? data.investigation2 : null}</div>
                            <div className="grid type3 " id="investigation3">{Array.isArray(data.investigation3) ? data.investigation3 : null}</div>
                            <div className="grid type4 " id="investigation4">{Array.isArray(data.investigation4) ? data.investigation4 : null}</div>
                        </div>
                        <div className=" hGridCSS doing" id="doing">
                            <div className="grid type0 " id="doing0">{Array.isArray(data.doing0) ? data.doing0 : null}</div>
                            <div className="grid type1 " id="doing1">{Array.isArray(data.doing1) ? data.doing1 : null}</div>
                            <div className="grid type2 " id="doing2">{Array.isArray(data.doing2) ? data.doing2 : null}</div>
                            <div className="grid type3 " id="doing3">{Array.isArray(data.doing3) ? data.doing3 : null}</div>
                            <div className="grid type4 " id="doing4">{Array.isArray(data.doing4) ? data.doing4 : null}</div>
                        </div>
                        <div className=" hGridCSS done" id="done">
                            <div className="grid type0 " id="done0">{Array.isArray(data.done0) ? data.done0 : null}</div>
                            <div className="grid type1 " id="done1">{Array.isArray(data.done1) ? data.done1 : null}</div>
                            <div className="grid type2 " id="done2">{Array.isArray(data.done2) ? data.done2 : null}</div>
                            <div className="grid type3 " id="done3">{Array.isArray(data.done3) ? data.done3 : null}</div>
                            <div className="grid type4 " id="done4">{Array.isArray(data.done4) ? data.done4 : null}</div>
                        </div>
                    </div>
                    
                </div>
                
            </div>
            
      
        </div>
    );
}

function updateTasks(){
    const allEntries = {};
    maps.forEach((mapName) => {
      const mapData = yData.get(mapName);
      
      const mapEntries = mapData ? Array.from(mapData.entries()):[];
      allEntries[mapName] = mapEntries.map(([key,value]) => (
        <div key={key} className="hGrid-item" data-keyvalue={key} 
        onDoubleClick={() => handleItemClick(key,value,mapName)} draggable="true"
        /*onDragStart={(event) => dragMoveStart(event)} 
        onDragEnd={(event) => dragMoveEnd(event,updateDataOnTaskMove)}*/
        style={{/*left:`${value.elemLeft}px`,top:`${value.elemTop}px`*/
                left:`${value.elemLeft}%`,top:`${value.elemTop}%`,
                width:`${value.width}px`,height:`${value.height}px`,background: value.taskColor || "white",zIndex:value.zIndex ?? 1}}>
          <p className="iconTitle">{value.taskTitle}</p>
          <p className="difficultyText">{value.difficulty ?? 0}</p>
        </div>
      ))
    })
    return allEntries;
  }

  const handleItemClick = (key,value,mapName) => {
        
    //1は普通の方，2はhistory
    openTask(key,value,mapName,"2");
  };
